<app-loading *ngIf="loading"></app-loading>

<div class="container" *ngIf="!loading">
  <div class="head">
    <yoo-button-icon
      neutral
      medium
      emphasis
      icon="arrow-left"
      (click)="handleBack()"
    ></yoo-button-icon>
    <div class="text" *ngIf="table.receiptType == 'USER'">
      <h3>Meus comprovantes</h3>
      <p>Informações da sua comanda individual.<br>
      Não incluímos todas as pessoas da mesa.</p>
    </div>
    <div class="text" *ngIf="table.receiptType == 'ALL'">
      <h3>Comprovantes da mesa</h3>
      <p>Informações de cada integrante da mesa.<br>
      Você pode conferir quanto cada pessoa pagou.</p>
    </div>
  </div>
  <div class="body" *ngIf="receipts.length">
    <app-receipt *ngFor="let payment of receipts" [payment]="payment" [table]="table"></app-receipt>
  </div>

  <div class="body empty" *ngIf="!receipts.length">
    <p>Nenhum comprovante encontrado</p>
  </div>

  <div class="footer">
    <yoo-button
      primary
      large
      emphasis
      [block]="true"
      (click)="handleBack()"
    >
      <span>Voltar ao início</span>
    </yoo-button>
  </div>
</div>